import { FieldRepository } from "@/core/fields";
// Individual field definitions (for registration and lookups)
export const FIELDS = new FieldRepository([
    // Basic fields
    {
        key: "delegacion_zona_de_ventas",
        label: "Delegación + Sala + Ruta",
        type: "string",
        align: "left",
    },
    {
        key: "delegacion",
        label: "Delegación",
        type: "string",
        align: "left",
    },
    {
        key: "zona_de_ventas",
        label: "Ruta",
        type: "string",
        align: "left",
    },
    {
        key: "distribuidor",
        label: "Distribuidor",
        type: "string",
        align: "left",
    },
    // Volumen fields (individual)
    {
        key: "volumen.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.cajas_faltantes",
        label: "Cajas Faltantes",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Volumen Acumulado fields (individual)
    {
        key: "volumen_acumulado.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen_acumulado.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.cajas_faltantes",
        label: "Cajas Faltantes",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Clientes fields (individual)
    {
        key: "clientes.periodo_actual",
        label: "Periodo Actual",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.periodo_anterior",
        label: "Periodo Anterior",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.objetivo",
        label: "Objetivo",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.clientes_faltantes",
        label: "Faltantes",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Ref Promedio fields (individual)
    {
        key: "ref_promedio.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "ref_promedio.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "ref_promedio.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // GDA fields (individual)
    {
        key: "gda.obj_ho_f1",
        label: "Obj HO F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f1",
        label: "Rtdo HO F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f2",
        label: "Obj HO F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f2",
        label: "Rtdo HO F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f3",
        label: "Obj HO F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f3",
        label: "Rtdo HO F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f1",
        label: "Obj AL F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f1",
        label: "Rtdo AL F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f2",
        label: "Obj AL F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f2",
        label: "Rtdo AL F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f3",
        label: "Obj AL F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f3",
        label: "Rtdo AL F3",
        type: "float",
        align: "right",
    },
    // Computed total fields
    {
        key: "total_volumen",
        label: "Total Volumen",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "total_volumen_acumulado",
        label: "Total Volumen Acumulado",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
]);
// Helper function to get field by key
const getField = (key, overrides = {}) => {
    return Object.assign(Object.assign({}, FIELDS.get(key)), overrides);
};
// Grouped table fields structure for display
export const TABLE_FIELDS = [
    // Basic fields (no group)
    getField("delegacion_zona_de_ventas", { width: "220px" }),
    getField("distribuidor", { width: "300px" }),
    // Objetivos año actual
    {
        key: "objetivos_mes_actual",
        label: "Objetivos mes actual",
        type: "group",
        color: "rgb(42,76,127)",
        children: [
            getField("objetivos_mes_actual.volumen"),
            getField("objetivos_mes_actual.volumen_acumulado"),
            getField("objetivos_mes_actual.clientes"),
            getField("objetivos_mes_actual.ref_promedio", {
                type: "float"
            }),
            getField("objetivos_mes_actual.ho_f1"),
            getField("objetivos_mes_actual.ho_f2"),
            getField("objetivos_mes_actual.ho_f3"),
            getField("objetivos_mes_actual.al_f1"),
            getField("objetivos_mes_actual.al_f2"),
            getField("objetivos_mes_actual.al_f3"),
        ],
    },
    // Resultados año actual
    {
        key: "resultados_mes_actual",
        label: "Resultados mes actual",
        type: "group",
        color: "rgb(251,0,7)",
        children: [
            getField("resultados_mes_actual.volumen"),
            getField("resultados_mes_actual.volumen_acumulado"),
            getField("resultados_mes_actual.clientes"),
            getField("resultados_mes_actual.ref_promedio", {
                type: "float"
            }),
            getField("resultados_mes_actual.ho_f1"),
            getField("resultados_mes_actual.ho_f2"),
            getField("resultados_mes_actual.ho_f3"),
            getField("resultados_mes_actual.al_f1"),
            getField("resultados_mes_actual.al_f2"),
            getField("resultados_mes_actual.al_f3"),
        ],
    },
    // % Cumplimiento
    {
        key: "porcentaje_cumplimiento",
        label: "% Cumplimiento",
        type: "group",
        color: "rgb(0,0,0)",
        children: [
            getField("porcentaje_cumplimiento.volumen"),
            getField("porcentaje_cumplimiento.volumen_acumulado"),
            getField("porcentaje_cumplimiento.clientes"),
            getField("porcentaje_cumplimiento.ref_promedio"),
            getField("porcentaje_cumplimiento.ho_f1"),
            getField("porcentaje_cumplimiento.ho_f2"),
            getField("porcentaje_cumplimiento.ho_f3"),
            getField("porcentaje_cumplimiento.al_f1"),
            getField("porcentaje_cumplimiento.al_f2"),
            getField("porcentaje_cumplimiento.al_f3"),
        ],
    },
    // % Cumplimiento
    {
        key: "importes",
        label: "Importes",
        type: "group",
        color: "rgb(22,165,63)",
        children: [
            getField("importes.volumen"),
            getField("importes.volumen_acumulado"),
            getField("importes.clientes"),
            getField("importes.ref_promedio"),
            getField("importes.ho_f1"),
            getField("importes.ho_f2"),
            getField("importes.ho_f3"),
            getField("importes.al_f1"),
            getField("importes.al_f2"),
            getField("importes.al_f3"),
        ],
    },
    // Total a cobrar
    {
        key: "total_a_cobrar",
        label: "Total a cobrar",
        type: "group",
        color: "rgb(251,0,7)",
        children: [
            //
            getField("totals.total_a_cobrar", {
                type: "float"
            }),
            getField("totals.maximo_teorico"),
            getField("totals.porcentaje_cumplimiento"),
        ],
    },
    //
    getField("totals.concepto_variable", {
        color: "rgb(251,0,7)",
        type: "integer"
    }),
    getField("totals.porcentaje_coeficiente", {
        color: "rgb(251,0,7)",
    }),
    getField("totals.resultado_total", {
        color: "rgb(251,0,7)",
    }),
];
// Filter fields
export const FILTER_FIELDS = ["delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "distribuidor"];
// Sortable fields
export const SORTABLE_FIELDS = [
    "delegacion_zona_de_ventas",
    "distribuidor",
    "volumen.periodo_actual",
    "volumen.periodo_anterior",
    "volumen.objetivo_porcentaje",
    "volumen.porcentaje_conseguido",
    "volumen_acumulado.periodo_actual",
    "volumen_acumulado.porcentaje_conseguido",
    "clientes.periodo_actual",
    "clientes.periodo_anterior",
    "total_volumen",
    "total_volumen_acumulado",
];
// Default sort configuration
export const DEFAULT_SORTS = [{ field: "delegacion_zona_de_ventas", direction: "asc" }];
// Preset sort configurations
export const PRESET_SORTS = [
    {
        label: "Por Distribuidor A-Z",
        sorts: [{ field: "distribuidor", direction: "asc" }],
    },
    {
        label: "Por Volumen (Mayor a Menor)",
        sorts: [{ field: "volumen.periodo_actual", direction: "desc" }],
    },
    {
        label: "Por % Conseguido (Mayor a Menor)",
        sorts: [{ field: "volumen.porcentaje_conseguido", direction: "desc" }],
    },
    {
        label: "Por Distribuidor + Volumen Desc",
        sorts: [
            { field: "distribuidor", direction: "asc" },
            { field: "volumen.periodo_actual", direction: "desc" },
        ],
    },
    {
        label: "Por Delegación + % Conseguido",
        sorts: [
            { field: "delegacion_zona_de_ventas", direction: "asc" },
            { field: "volumen.porcentaje_conseguido", direction: "desc" },
        ],
    },
];
